import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '../hooks/useSession.tsx';
import { useT } from '../i18n/index.ts';

/**
 * Route guard for the authenticated shell (forked local from the
 * console-shared `createRequireAuth` factory, epic #897 PR 3 — identical
 * loading / redirect-with-state behavior).
 */

interface Props {
  readonly children: ReactNode;
}

export function RequireAuth({ children }: Props): JSX.Element {
  const { status } = useSession();
  const location = useLocation();
  const t = useT();

  if (status === 'loading') {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-canvas px-8 text-sm text-paper-low"
        role="status"
        aria-live="polite"
      >
        <p>{t('common.session.checking')}</p>
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
